import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, desc, moreTo, moreLabel = '查看更多' }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        <div className="flex items-center gap-3">
          <span className="w-1 h-6 rounded-full bg-accent-500" />
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{title}</h2>
        </div>
        {desc && <p className="mt-2 text-sm text-foreground-600 max-w-2xl">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}